import { useState, useRef, useEffect } from "react";
import { Helmet } from "react-helmet";
import Sidebar from "./Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Palette } from "lucide-react";
import QRCode from "qrcode";
import SEOHelmet from "../../../components/SEOHelmet";

export default function QRStylingPage() {
    const [text, setText] = useState("");
    const [size, setSize] = useState(250);
    const [fgColor, setFgColor] = useState("#000000");
    const [bgColor, setBgColor] = useState("#ffffff");
    const [gradient, setGradient] = useState(false);
    const [logo, setLogo] = useState(null);
    const [format, setFormat] = useState("png");
    const [roundDots, setRoundDots] = useState(false);
    const [logoPosition, setLogoPosition] = useState("center"); // center | top | bottom
    const [logoPlacement, setLogoPlacement] = useState("inside"); // "inside" or "outside"
    const [wifiSSID, setWifiSSID] = useState("");
    const [wifiPassword, setWifiPassword] = useState("");
    const [emailAddress, setEmailAddress] = useState("");




    // Common inp
    // URL type uses `text`
    // Phone uses `text` as phone number
    // SMS uses `text` as number and separate message
    const [smsMessage, setSmsMessage] = useState("");


    // vCard / Contact
    const [vcardData, setVcardData] = useState({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
    });

    // Event / Calendar
    const [eventData, setEventData] = useState({
        title: "",
        start: "",
        end: "",
        location: "",
    });

    // Payment
    const [paymentData, setPaymentData] = useState({
        method: "", // e.g., UPI, Bitcoin
        recipient: "",
        amount: "",
        note: "",
    });







    const canvasRef = useRef();
    const navigate = useNavigate();

    const location = useLocation();
    const selectedQrType = location.state?.qrType || "text";
    console.log("fffffff", selectedQrType)
    const [qrType, setQrType] = useState(selectedQrType);





    useEffect(() => {
        setText("");
        setEmailAddress("");
        setWifiSSID("");
        setWifiPassword("");
        setSmsMessage("");
        setVcardData({ firstName: "", lastName: "", phone: "", email: "" });
        setEventData({ title: "", start: "", end: "", location: "" });
        setPaymentData({ method: "", recipient: "", amount: "", note: "" });
    }, [qrType]);


    const isValidUpi = (upi) => /^[\w.-]+@[\w.-]+$/.test(upi);


    // Generate QR code
    useEffect(() => {

        // if (!text && qrType === "url") return;
        // if (qrType === "wifi" && (!wifiSSID || !wifiPassword)) return;
        // if (qrType === "email" && !emailAddress) return;
        debugger

        let qrContent = "";

        switch (qrType) {
            case "text":
                qrContent = text || "";
                break;

            case "url":
                qrContent = text && /^https?:\/\/.+/.test(text) ? text : "";
                break;

            case "email":
                qrContent =
                    emailAddress && /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(emailAddress)
                        ? `mailto:${emailAddress}`
                        : "";
                break;

            case "phone":
                qrContent =
                    text && /^[0-9+\-() ]{6,15}$/.test(text)
                        ? `tel:${text}`
                        : "";
                break;

            case "sms":
                qrContent =
                    text && smsMessage
                        ? `SMSTO:${text}:${smsMessage}`
                        : "";
                break;

            case "wifi":
                qrContent =
                    wifiSSID && wifiPassword
                        ? `WIFI:T:WPA;S:${wifiSSID};P:${wifiPassword};;`
                        : "";
                break;

            case "vcard":
                if (
                    vcardData.firstName ||
                    vcardData.lastName ||
                    vcardData.phone ||
                    vcardData.email
                ) {
                    const fullName = `${vcardData.firstName || ""} ${vcardData.lastName || ""}`.trim();

                    qrContent = [
                        "BEGIN:VCARD",
                        "VERSION:3.0",
                        `N:${vcardData.lastName || ""};${vcardData.firstName || ""};;;`,
                        `FN:${fullName || vcardData.firstName || vcardData.lastName || "Unknown"}`,
                        vcardData.phone ? `TEL;TYPE=CELL:${vcardData.phone}` : "",
                        vcardData.email ? `EMAIL;TYPE=INTERNET:${vcardData.email}` : "",
                        "END:VCARD",
                    ]
                        .filter(Boolean)
                        .join("\r\n"); // must use CRLF
                } else {
                    qrContent = "";
                }
                break;


            case "event":
                if (eventData.title && eventData.start && eventData.end) {
                    qrContent = `BEGIN:VEVENT\nSUMMARY:${eventData.title}\nDTSTART:${eventData.start}\nDTEND:${eventData.end}\nLOCATION:${eventData.location || ""}\nEND:VEVENT`;
                } else {
                    qrContent = "";
                }
                break;

            // case "payment":
            //   if (paymentData.method === "upi") {
            //     qrContent = paymentData.recipient && paymentData.amount
            //       ? `upi://pay?pa=${paymentData.recipient}&pn=${encodeURIComponent(paymentData.name || "")}&am=${paymentData.amount}&cu=INR&tn=${encodeURIComponent(paymentData.note || "")}`
            //       : "";
            //   } else if (paymentData.method === "bitcoin") {
            //     qrContent = paymentData.recipient && paymentData.amount
            //       ? `bitcoin:${paymentData.recipient}?amount=${paymentData.amount}&message=${encodeURIComponent(paymentData.note || "")}`
            //       : "";
            //   } else if (paymentData.method === "paypal") {
            //     qrContent = paymentData.recipient && paymentData.amount
            //       ? `https://www.paypal.me/${paymentData.recipient}/${paymentData.amount}`
            //       : "";
            //   } else {
            //     qrContent = "";
            //   }
            //   break;

            case "payment":
                if (paymentData.method === "upi") {
                    const amount = parseFloat(paymentData.amount);
                    if (isValidUpi(paymentData.recipient) && amount > 0) {
                        qrContent =
                            `upi://pay?pa=${paymentData.recipient}` +
                            `&pn=${encodeURIComponent(paymentData.name || "Merchant")}` +
                            `&am=${amount}` +
                            `&cu=INR` +
                            (paymentData.note ? `&tn=${encodeURIComponent(paymentData.note)}` : "");
                    } else {
                        qrContent = "";
                    }
                }
                break;






            default:
                qrContent = "";
        }

        console.log("QR Content:", qrContent);

        // moreomkar972-1@okaxis/Omkar More

        if (!qrContent) return;


        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        canvas.width = size;
        canvas.height = size;

        // Clear canvas
        ctx.clearRect(0, 0, size, size);

        // Generate QR to temporary canvas
        const tempCanvas = document.createElement("canvas");
        tempCanvas.width = size;
        tempCanvas.height = size;

        QRCode.toCanvas(tempCanvas, qrContent, {
            width: size,
            margin: 1,
            color: { dark: fgColor, light: bgColor },
            errorCorrectionLevel: "H",
        }, (err) => {
            if (err) return console.error(err);

            if (gradient) {
                // Create gradient
                const grad = ctx.createLinearGradient(0, 0, size, size);
                grad.addColorStop(0, "#00FFFF");
                grad.addColorStop(1, "#FF00FF");

                // Draw gradient only where QR dots exist
                ctx.fillStyle = grad;
                const imgData = tempCanvas.getContext("2d").getImageData(0, 0, size, size);
                for (let y = 0; y < size; y++) {
                    for (let x = 0; x < size; x++) {
                        const idx = (y * size + x) * 4;
                        // If QR dot is dark (non-white)
                        if (imgData.data[idx] < 128) {
                            ctx.fillRect(x, y, 1, 1);
                        }
                    }
                }
            } else {
                // No gradient, just copy QR
                ctx.drawImage(tempCanvas, 0, 0);
            }



            if (logo) {
                const img = new Image();
                img.src = logo;
                img.crossOrigin = "anonymous";

                const drawLogo = () => {
                    const logoSize = Math.min(size * 0.25, 120);
                    const padding = Math.max(size * 0.03, 6);
                    let logoX = size / 2 - logoSize / 2;
                    let logoY;

                    if (logoPlacement === "inside") {
                        switch (logoPosition) {
                            case "top":
                                logoY = padding;
                                break;
                            case "bottom":
                                logoY = size - logoSize - padding;
                                break;
                            default:
                                logoY = size / 2 - logoSize / 2;
                        }
                    } else {
                        // Outside: place logo above or below canvas
                        logoY = logoPosition === "top" ? -logoSize - padding : size + padding;
                    }

                    // Draw background & circular clip
                    ctx.save();
                    ctx.beginPath();
                    ctx.arc(logoX + logoSize / 2, logoY + logoSize / 2, logoSize / 2 + padding, 0, 2 * Math.PI);
                    ctx.fillStyle = "#fff";
                    ctx.fill();
                    ctx.lineWidth = Math.max(2, padding / 2);
                    ctx.strokeStyle = "#e0e0e0";
                    ctx.stroke();
                    ctx.restore();

                    ctx.save();
                    ctx.beginPath();
                    ctx.arc(logoX + logoSize / 2, logoY + logoSize / 2, logoSize / 2, 0, 2 * Math.PI);
                    ctx.closePath();
                    ctx.clip();
                    ctx.drawImage(img, logoX, logoY, logoSize, logoSize);
                    ctx.restore();
                };

                if (img.complete) {
                    drawLogo(); // Image already loaded
                } else {
                    img.onload = drawLogo; // Wait for load
                }
            }






        });
    }, [qrType,
        text,
        emailAddress,
        wifiSSID,
        wifiPassword,
        smsMessage,
        vcardData,
        eventData,
        paymentData,
        size,
        fgColor,
        bgColor]);


    useEffect(() => {
        if (logoPlacement === "inside") setLogoPosition("center");
        else if (logoPlacement === "outside") setLogoPosition("top");
    }, [logoPlacement]);


    // Rounded Dots Effect






    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) setLogo(URL.createObjectURL(file));
    };

    // const downloadQRCode = () => {
    //     if (!canvasRef.current) return;
    //     const link = document.createElement("a");
    //     link.href = canvasRef.current.toDataURL(`image/${format}`);
    //     link.download = `qr-code.${format}`;
    //     link.click();
    // };

    const downloadQRCode = () => {
        if (!canvasRef.current) return;

        const qrCanvas = canvasRef.current;
        const qrWidth = qrCanvas.width;
        const qrHeight = qrCanvas.height;

        // Create a new canvas for download
        const downloadCanvas = document.createElement("canvas");
        const ctx = downloadCanvas.getContext("2d");

        let totalHeight = qrHeight;

        let logoImg = null;
        if (logo && logoPlacement === "outside") {
            logoImg = new Image();
            logoImg.src = logo;
            logoImg.crossOrigin = "anonymous";

            logoImg.onload = () => {
                const logoWidth = qrWidth; // make logo width same as QR
                const logoHeight = (logoImg.height / logoImg.width) * logoWidth;

                // total height depends on logo position
                if (logoPosition === "top" || logoPosition === "bottom") {
                    totalHeight = qrHeight + logoHeight + 18; // 16px padding
                }

                downloadCanvas.width = qrWidth;
                downloadCanvas.height = totalHeight;

                ctx.fillStyle = "#fff"; // white background
                ctx.fillRect(0, 0, downloadCanvas.width, downloadCanvas.height);

                if (logoPosition === "top") {
                    ctx.drawImage(logoImg, 0, 0, logoWidth, logoHeight);
                    ctx.drawImage(qrCanvas, 0, logoHeight + 16, qrWidth, qrHeight);
                } else if (logoPosition === "bottom") {
                    ctx.drawImage(qrCanvas, 0, 0, qrWidth, qrHeight);
                    ctx.drawImage(logoImg, 0, qrHeight + 1, logoWidth, logoHeight);
                }

                // Download
                const link = document.createElement("a");
                link.href = downloadCanvas.toDataURL(`image/${format}`);
                link.download = `qr-code.${format}`;
                link.click();
            };
        } else {
            // If logo is inside or no logo, just download QR canvas
            const link = document.createElement("a");
            link.href = qrCanvas.toDataURL(`image/${format}`);
            link.download = `qr-code.${format}`;
            link.click();
        }
    };






    return (
        <div className="flex min-h-screen bg-gray-50">
            <Sidebar />
            <div className="flex-1 md:ml-64">
            <SEOHelmet
  title="QR Code Styler & Customizer"
  description="Style and customize your QR codes with colors, shapes, logos, and more. Make your QR codes unique and visually appealing with our free QR Code Styler."
  keywords="QR code styler, QR code customizer, customize QR code, QR code design, colored QR code, stylish QR code"
  url="https://omkarmore.com/qrstyling"
  image="https://omkarmore.com/LOGO_512.png"
/>


                {/* Back Button */}
                <div className="sticky top-0 z-30 bg-gray-50 py-4 px-6 shadow-sm">
                    <button
                        onClick={() => navigate("/tools")}
                        className="flex items-center gap-2 text-cyan-700 font-medium hover:text-cyan-600 transition"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        Back to Tools
                    </button>
                </div>

                {/* Page Card */}
                <main className="bg-white p-6 md:p-8 rounded-2xl shadow-lg max-w-4xl mx-4 md:ml-8 mt-24 md:mt-12 w-full">
                    <header className="text-center md:text-left mb-10">
                        <h1 className="text-3xl md:text-4xl font-extrabold text-cyan-700">
                            QR Styling
                        </h1>
                        <p className="mt-3 text-gray-600 text-base md:text-lg">
                            Customize QR codes with gradients, logos, rounded dots, and advanced styles. Preview and download instantly.
                        </p>
                    </header>

                    <section className="space-y-8">
                        {/* Input */}
                        <div className="flex flex-col gap-2">

                            {/* Text */}
                            {qrType === "text" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">Enter Text</label>
                                    <input
                                        type="text"
                                        placeholder="Enter your text"
                                        value={text}
                                        onChange={(e) => setText(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}

                            {/* URL */}
                            {qrType === "url" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">Website URL</label>
                                    <input
                                        type="url"
                                        placeholder="https://example.com"
                                        value={text}
                                        onChange={(e) => setText(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}

                            {/* Email */}
                            {qrType === "email" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">Email Address</label>
                                    <input
                                        type="email"
                                        placeholder="example@mail.com"
                                        value={emailAddress}
                                        onChange={(e) => setEmailAddress(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}

                            {/* Phone */}
                            {qrType === "phone" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">Phone Number</label>
                                    <input
                                        type="tel"
                                        placeholder="+1234567890"
                                        value={text}
                                        onChange={(e) => setText(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}

                            {/* SMS */}
                            {qrType === "sms" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">Recipient Number</label>
                                    <input
                                        type="tel"
                                        placeholder="+1234567890"
                                        value={text}
                                        onChange={(e) => setText(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">Message</label>
                                    <input
                                        type="text"
                                        placeholder="Your message"
                                        value={smsMessage}
                                        onChange={(e) => setSmsMessage(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}

                            {/* Wi-Fi */}
                            {qrType === "wifi" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">Wi-Fi SSID</label>
                                    <input
                                        type="text"
                                        placeholder="Wi-Fi Name"
                                        value={wifiSSID}
                                        onChange={(e) => setWifiSSID(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">Wi-Fi Password</label>
                                    <input
                                        type="password"
                                        placeholder="Password"
                                        value={wifiPassword}
                                        onChange={(e) => setWifiPassword(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}

                            {/* vCard / Contact */}
                            {qrType === "vcard" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">First Name</label>
                                    <input
                                        type="text"
                                        placeholder="First Name"
                                        value={vcardData.firstName}
                                        onChange={(e) => setVcardData({ ...vcardData, firstName: e.target.value })}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">Last Name</label>
                                    <input
                                        type="text"
                                        placeholder="Last Name"
                                        value={vcardData.lastName}
                                        onChange={(e) => setVcardData({ ...vcardData, lastName: e.target.value })}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">Phone</label>
                                    <input
                                        type="tel"
                                        placeholder="+1234567890"
                                        value={vcardData.phone}
                                        onChange={(e) => setVcardData({ ...vcardData, phone: e.target.value })}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">Email</label>
                                    <input
                                        type="email"
                                        placeholder="example@mail.com"
                                        value={vcardData.email}
                                        onChange={(e) => setVcardData({ ...vcardData, email: e.target.value })}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}

                            {/* Event */}
                            {qrType === "event" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">Event Title</label>
                                    <input
                                        type="text"
                                        placeholder="Event Name"
                                        value={eventData.title}
                                        onChange={(e) => setEventData({ ...eventData, title: e.target.value })}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">Start (YYYYMMDDTHHMMSS)</label>
                                    <input
                                        type="text"
                                        placeholder="20250919T140000"
                                        value={eventData.start}
                                        onChange={(e) => setEventData({ ...eventData, start: e.target.value })}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">End (YYYYMMDDTHHMMSS)</label>
                                    <input
                                        type="text"
                                        placeholder="20250919T160000"
                                        value={eventData.end}
                                        onChange={(e) => setEventData({ ...eventData, end: e.target.value })}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 mt-2">Location</label>
                                    <input
                                        type="text"
                                        placeholder="Location"
                                        value={eventData.location}
                                        onChange={(e) => setEventData({ ...eventData, location: e.target.value })}
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}

                            {/* Payment */}
                            {qrType === "payment" && (
                                <>
                                    <label className="block text-sm font-medium text-gray-700">Payment Method</label>
                                    <input
                                        type="text"
                                        placeholder="UPI / Bitcoin"
                                        value={paymentData.method}
                                        onChange={(e) =>
                                            setPaymentData({ ...paymentData, method: e.target.value })
                                        }
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />

                                    <label className="block text-sm font-medium text-gray-700 mt-2">Recipient UPI ID</label>
                                    <input
                                        type="text"
                                        placeholder="Recipient UPI ID (e.g. moreomkar972-1@okaxis)"
                                        value={paymentData.recipient}
                                        onChange={(e) =>
                                            setPaymentData({ ...paymentData, recipient: e.target.value })
                                        }
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />

                                    <label className="block text-sm font-medium text-gray-700 mt-2">Recipient Name</label>
                                    <input
                                        type="text"
                                        placeholder="e.g. Omkar More"
                                        value={paymentData.name || ""}
                                        onChange={(e) =>
                                            setPaymentData({ ...paymentData, name: e.target.value })
                                        }
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />

                                    <label className="block text-sm font-medium text-gray-700 mt-2">Amount</label>
                                    <input
                                        type="number"
                                        placeholder="Amount"
                                        value={paymentData.amount}
                                        onChange={(e) =>
                                            setPaymentData({ ...paymentData, amount: e.target.value })
                                        }
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />

                                    <label className="block text-sm font-medium text-gray-700 mt-2">Note</label>
                                    <input
                                        type="text"
                                        placeholder="Optional note"
                                        value={paymentData.note}
                                        onChange={(e) =>
                                            setPaymentData({ ...paymentData, note: e.target.value })
                                        }
                                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
                                    />
                                </>
                            )}



                        </div>


                        {/* Basic Options */}

                        {selectedQrType && (
                            <div className="flex flex-wrap items-center gap-4 mt-6 bg-white p-4 rounded-lg shadow-md">

                                {/* Gradient Toggle */}
                                <div className="flex items-center gap-2 flex-shrink-0 h-10">
                                    <input
                                        type="checkbox"
                                        checked={gradient}
                                        onChange={() => setGradient(!gradient)}
                                        className="h-5 w-5 accent-cyan-500 cursor-pointer"
                                    />
                                    <label className="text-gray-700 text-sm font-medium">Use Gradient</label>
                                </div>

                                {/* Rounded Dots Toggle */}
                                {/* <div className="flex items-center gap-2 flex-shrink-0">
  <input
    type="checkbox"
    checked={roundDots}
    onChange={() => setRoundDots(!roundDots)}
    className="h-4 w-4 sm:h-5 sm:w-5 accent-cyan-500 cursor-pointer"
  />
  <label className="text-gray-700 text-sm sm:text-base font-medium select-none">
    Rounded Dots
  </label>
</div> */}


                                {/* QR Size */}
                                <div className="flex flex-col items-start w-36 sm:w-40 flex-shrink-0 h-10 justify-center">
                                    <label className="text-gray-700 text-sm font-medium mb-1">
                                        QR Size: <span className="font-semibold text-cyan-600">{size}px</span>
                                    </label>
                                    <input
                                        type="range"
                                        min="150"
                                        max="500"
                                        value={size}
                                        onChange={(e) => setSize(Number(e.target.value))}
                                        className="w-full h-2 accent-cyan-500 cursor-pointer rounded-lg"
                                    />
                                </div>

                                {/* Foreground Color */}
                                <div className="flex items-center gap-1 flex-shrink-0 h-10">
                                    <label className="text-gray-700 text-sm font-medium">Foreground</label>
                                    <div className="relative w-10 h-10">
                                        <input
                                            type="color"
                                            value={fgColor}
                                            onChange={(e) => setFgColor(e.target.value)}
                                            className="w-full h-full cursor-pointer border border-gray-300 rounded-full p-1"
                                        />
                                        <Palette
                                            size={20}
                                            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                                            color={fgColor}
                                        />
                                    </div>
                                </div>

                                {/* Background Color */}
                                <div className="flex items-center gap-1 flex-shrink-0 h-10">
                                    <label className="text-gray-700 text-sm font-medium">Background</label>
                                    <div className="relative w-10 h-10">
                                        <input
                                            type="color"
                                            value={bgColor}
                                            onChange={(e) => setBgColor(e.target.value)}
                                            className="w-full h-full cursor-pointer border border-gray-300 rounded-full p-1"
                                        />
                                        <Palette
                                            size={20}
                                            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                                            color={bgColor}
                                        />
                                    </div>
                                </div>

                            </div>
                        )}



                        {/* Advanced Options */}
                        {selectedQrType && (
                            <div className="flex flex-col gap-6 mt-6">
                                {/* Top Controls: Gradient and Rounded Dots */}


                                {/* Logo Options Grid */}
                                <div className="grid sm:grid-cols-3 gap-6">
                                    {/* Logo Upload */}
                                    <div className="flex flex-col">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Upload Logo
                                        </label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleLogoUpload}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 cursor-pointer hover:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 transition"
                                        />
                                        {logo && (
                                            <div className="mt-3 flex justify-center">
                                                <img
                                                    src={logo}
                                                    alt="QR Logo Preview"
                                                    className="h-24 w-auto object-contain rounded-lg border border-gray-200 shadow-md transition-all duration-300"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {/* Logo Placement */}
                                    <div className="flex flex-col">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Logo Placement
                                        </label>
                                        <select
                                            value={logoPlacement}
                                            onChange={(e) => setLogoPlacement(e.target.value)}
                                            className="border border-gray-300 rounded-lg px-3 py-2 w-full hover:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 transition"
                                        >
                                            <option value="inside">Inside QR</option>
                                            <option value="outside">Outside QR</option>
                                        </select>
                                        <p className="text-xs text-gray-500 mt-1">
                                            "Inside" embeds the logo within the QR, "Outside" places it above or below.
                                        </p>
                                    </div>

                                    {/* Logo Position */}
                                    <div className="flex flex-col">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Logo Position
                                        </label>
                                        <select
                                            value={logoPosition}
                                            onChange={(e) => setLogoPosition(e.target.value)}
                                            className="border border-gray-300 rounded-lg px-3 py-2 w-full hover:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 transition"
                                        >
                                            {logoPlacement === "inside" ? (
                                                <option value="center">Center</option>
                                            ) : (
                                                <>
                                                    <option value="top">Top</option>
                                                    <option value="bottom">Bottom</option>
                                                </>
                                            )}
                                        </select>
                                        <p className="text-xs text-gray-500 mt-1">
                                            Choose where the logo appears inside or outside the QR code.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}


                        {/* QR Preview */}
                        {selectedQrType && (
                            <div className="flex flex-col items-center gap-2 mt-8">
                                {/* Wrapper with border for outside logo */}
                                <div
                                    className={`flex flex-col items-center p-4 rounded-lg shadow-md transition-all duration-300 ${logo && logoPlacement === "outside" ? "border border-gray-300" : ""
                                        }`}
                                >
                                    {/* Logo Above QR */}
                                    {logo && logoPlacement === "outside" && logoPosition === "top" && (
                                        <img
                                            src={logo}
                                            alt="Logo Above QR"
                                            className="h-20 w-auto object-contain rounded-lg mb-3 transition-all duration-300"
                                        />
                                    )}

                                    {/* QR Canvas */}
                                    {/* <canvas
                                        ref={canvasRef}
                                        className={`transition-all duration-300 ${logo && logoPlacement === "outside" ? "border-none" : "border border-gray-300 rounded-md"}`}
                                    /> */}

                                    <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md mx-auto">
                                        <canvas
                                            ref={canvasRef}
                                            width={size}
                                            height={size}
                                            style={{ width: "100%", height: "auto" }} // scale to fit wrapper
                                            className="border border-gray-300 rounded-md"
                                        />
                                    </div>


                                    {/* Logo Below QR */}
                                    {logo && logoPlacement === "outside" && logoPosition === "bottom" && (
                                        <img
                                            src={logo}
                                            alt="Logo Below QR"
                                            className="h-20 w-auto object-contain rounded-lg mt-3 transition-all duration-300"
                                        />
                                    )}
                                </div>

                                <p className="text-gray-600 text-sm mt-2">Preview of your styled QR Code</p>
                            </div>
                        )}


                        {/* Download */}
                        {selectedQrType && (
                            <div className="text-center space-y-4 mt-8">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Download Format</label>
                                    <select value={format} onChange={(e) => setFormat(e.target.value)} className="border border-gray-300 rounded-lg px-3 py-2">
                                        <option value="png">PNG (best for web)</option>
                                        <option value="jpg">JPG (smaller size)</option>
                                        <option value="svg">SVG (infinite scaling)</option>
                                    </select>
                                </div>

                                <button
                                    onClick={downloadQRCode}
                                    className="px-8 py-3 bg-cyan-700 text-white font-semibold rounded-full shadow-md hover:bg-cyan-600 hover:shadow-lg transition"
                                >
                                    Download QR Code
                                </button>
                                <p className="text-gray-500 text-sm">
                                    Tip: Use logos for branding, gradients for style, and adjust size for printing or web.
                                </p>
                            </div>
                        )}
                    </section>
                </main>
                <br></br>

            </div>
        </div>
    );
}
